import { useState } from 'react'
import { useNavigate } from 'react-router'
import { Flex } from '@radix-ui/themes'
import { formatDate } from '@/lib/shipment'
import { Subscription, FlowerCollectionProduct, SubscriptionPlacement } from '~/api-client/data-contracts'
import { createClient } from '@/api-client'
import { Subscriptions } from '@/api-client/Subscriptions'
import { useConfirmationModal } from '~/components/subscription/confirmation-modal'
import * as styles from './styles.css'
import info from './info.svg'

export const InBulkCard: React.FC<{
  subscription: Subscription
  product: FlowerCollectionProduct
  inBulkProducts: FlowerCollectionProduct[]
  placements: SubscriptionPlacement[]
}> = ({ subscription, product, inBulkProducts, placements }) => {
  const navigate = useNavigate()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { confirm, confirmationModal } = useConfirmationModal()

  if (!subscription) return  null

  const date = formatDate(subscription.attributes.next_deliver_at * 1000, 'M/d（E）')
  const status = placements[0]?.attributes?.status
  const price = product.attributes.bulk_discounted_price + inBulkProducts.reduce((sum, item) => sum + item.attributes.bulk_discounted_price, 0)

  const handleCancel = async () => {
    if (!(await confirm('次回お届けのグッズをキャンセルします。よろしいですか？'))) return

    const client = createClient(Subscriptions)
    setIsSubmitting(true)

    try {
      await Promise.all(inBulkProducts.map((p) => client.deleteSubscriptionsSubscriptionIdInBulkProductsId(subscription.id, p.id)))
      navigate(0) // reload
    } catch (error: any) {
      alert(error.response?.data?.error?.message_displayable ?? 'エラーが発生しました')
    } finally {
      setIsSubmitting(false)
    }
  }

  if (subscription && status !== 'skipped' && inBulkProducts.length > 0) {
    return (
      <Flex direction="column" align="start" gap="4px" className={styles.card}>
        <h3 className={styles.cardHeading}>{date}はこちらのグッズを一緒にお届け</h3>
        <Flex direction="row" align="start" gap="4px" className={styles.note}>
          <img src={info} className={styles.noteIcon} />
          次回は通常の定期便代金 + グッズの代金の合計{Intl.NumberFormat().format(price)}円が請求されます
        </Flex>
        <Flex direction="column" align="start" gap="8px">
          <Flex direction="row" align="start" gap="8px" pt="8px">
            {inBulkProducts.map((item) => (
              <Flex key={item.id} direction="row" align="center" gap="8px">
                <img src={item.attributes.image_small_url} className={styles.goodiesThumbnail} />
                <div>
                  <p className={styles.goodiesName}>{item.attributes.name}</p>
                  <p className={styles.goodiesPrice}>{Intl.NumberFormat().format(item.attributes.bulk_discounted_price)}円</p>
                </div>
              </Flex>
            ))}
          </Flex>
          <button onClick={handleCancel} disabled={isSubmitting} className={styles.cancelButton}>
            グッズをキャンセル
          </button>
        </Flex>
        {confirmationModal}
      </Flex>
    )
  } else {
    return null
  }
}
